import { makeStyles } from '@material-ui/core/styles'

const GlobalAiChatStyles = makeStyles((theme) => ({
  '@keyframes bounce-twice': {
    '0%, 100%': {
      transform: 'translateY(0)',
    },
    '25%': {
      transform: 'translateY(-10px)',
    },
    '50%': {
      transform: 'translateY(0)',
    },
    '75%': {
      transform: 'translateY(-5px)',
    },
  },
  floatingContainer: {
    position: 'fixed',
    bottom: theme.spacing(3),
    right: theme.spacing(3),
    zIndex: 1000,
  },
  floatingButton: {
    zIndex: 9000,
    // New styles to make the button look like a message bubble
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
      '&::after': {
        borderColor: `${theme.palette.primary.dark} transparent transparent transparent`,
      },
    },
    // Make the button a rounded rectangle
    borderRadius: '30px',
    width: 60,
    height: 65,
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.2)',
    // Add a triangle to the bottom right for the "tail"
    '&::after': {
      content: '""',
      position: 'absolute',
      bottom: -2,
      right: 40,
      width: 0,
      height: 0,
      borderStyle: 'solid',
      borderWidth: '26px 20px 0 0',
      borderColor: `${theme.palette.primary.main} transparent transparent transparent`,
      transform: 'rotate(-88deg)',
    },
    animation: '$bounce-twice 1.5s ease-in-out',
  },
  floatingButtonIcon: {
    fontSize: 45,
  },
  mobileFloatingButton: {
    zIndex: 9000,
    positio: 'fixed',
    left: 30,
    bottom: 42,
    backgroundColor: theme.palette.primary.main,
    borderTopLeftRadius: 60,
    borderBottomLeftRadius: 60,
    padding: 0,
    height: 35,
    minWidth: '35px',
    color: theme.palette.primary.contrastText,
  },
  mobileFloatingButtonIcon: {
    fontSize: 22,
    padding: 0,
  },
  chatWindow: {
    position: 'absolute',
    bottom: '70px',
    right: 0,
    width: 320,
    height: 450,
    display: 'flex',
    flexDirection: 'column',
    borderRadius: theme.spacing(1),
    overflow: 'hidden',
  },
  chatHeader: {
    backgroundColor: theme.color.rutgersRed,
    color: theme.color.white,
    padding: theme.spacing(2),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  chatBody: {
    flexGrow: 1,
    padding: theme.spacing(2),
    overflowY: 'auto',
    backgroundColor: theme.palette.background.default,
    // Adds smooth scroll animation when new messages are added
    scrollBehavior: 'smooth',
  },
  // The message bubbles are now styled directly with these classes
  botMessage: {
    padding: theme.spacing(1.5),
    maxWidth: '80%',
    borderRadius: theme.spacing(3),
    backgroundColor: theme.palette.backgroundColor.ternary,
    borderBottomLeftRadius: 0,
  },
  userMessage: {
    padding: theme.spacing(1.5),
    maxWidth: '80%',
    borderRadius: theme.spacing(3),
    backgroundColor: theme.palette.backgroundColor.ternary,
    color: theme.palette.text.primary,
    borderBottomRightRadius: 0,
  },
  departmentButton: {
    borderRadius: theme.spacing(1),
    backgroundColor: theme.color.rutgersRed,
    color: theme.color.white,
    textDecoration: 'underline',
  },
  // Containers for each message that manage avatar and message bubble alignment
  messageContainer: {
    display: 'flex',
    alignItems: 'flex-end',
    marginBottom: theme.spacing(1.5),
  },
  botMessageContainer: {
    justifySelf: 'flex-start',
    display: 'flex',
    justifyContent: 'flex-start',
    margin: '5px 0px 5px 0px',
  },
  userMessageContainer: {
    justifySelf: 'flex-end',
    display: 'flex',
    justifyContent: 'flex-end',
    flexDirection: 'row-reverse',
    margin: '5px 0px 5px 0px',
  },
  botAvatar: {
    marginRight: theme.spacing(1),
    alignSelf: 'flex-end',
    backgroundColor: theme.palette.backgroundColor.ternary,
  },
  userAvatar: {
    marginLeft: theme.spacing(1),
    alignSelf: 'flex-end',
  },
  typingIndicator: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: theme.spacing(1.5),
  },
  chatInput: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
  },
  iframeContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  iframeHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
  },
  iframe: {
    width: '100%',
    height: '100%',
    border: 'none',
  },
  closeChatButton: {
    color: 'white',
  },
}))

export default GlobalAiChatStyles
